// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AisLsJaE_AWnIhDlnTUV {
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 0.3s;
  font-weight: var(--button-font-weight);
  font-size: 1.125rem;
  line-height: 1.375rem;

  /* reset */
  border: none;
  outline: none;
  overflow: visible;
  padding: 0 2.5rem;
  -webkit-user-select: none;
          user-select: none;
  position: relative
}

.AisLsJaE_AWnIhDlnTUV.DHBUqUbAMMfB0v3PgvXr {
    height: unset;
    min-height: 4rem;
    padding: 0 1rem;
  }

.ZsVSWr4yl0WLP8wkMn40 {
  white-space: normal;
}

@media only screen and
  (max-width: 639px) {
    .AisLsJaE_AWnIhDlnTUV.DHBUqUbAMMfB0v3PgvXr {
      padding: 0 0.5rem;
    }
}

.pYLUj9noAqT8WytjDOOb {
  white-space: nowrap;
  width: 100%
}

.pYLUj9noAqT8WytjDOOb._jQ18NByxdvafkEjPWkf {
    white-space: normal;
    padding: 0.75rem 0;
  }

.pYLUj9noAqT8WytjDOOb.acaZyRNE4xfXFf2H3_Pj {
    visibility: hidden;
  }

.ntiSVvdX4_Z4uEfI2VNc {
  white-space: unset;
  -webkit-hyphens: auto;
          hyphens: auto;
  word-break: break-word;
}

.FINn846WpvpReeRlLCKs {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.35);
}

.cdc4_xoyu5lt350lFjqA {
  background: var(--primary-button-background);
  border-radius: 2.5rem;
  color: var(--white)
}

.cdc4_xoyu5lt350lFjqA:hover:not([disabled]) {
    background: var(--primary-button-hover-background);
    transition: 0.3s;
  }

.cdc4_xoyu5lt350lFjqA.v8v841M4DCcuCAwgrgy4 {
    background: var(--primary-button-inactive-background);
    opacity: 1;
  }

.O3f7ruZEAN4tCb1_HN2w {
  background: var(--primary-button-background-alt)
}

.O3f7ruZEAN4tCb1_HN2w:hover:not([disabled]) {
    background: var(--primary-button-hover-background-alt);
  }

.O3f7ruZEAN4tCb1_HN2w.v8v841M4DCcuCAwgrgy4 {
    background: var(--primary-button-inactive-background-alt);
  }

.pJ5lpFCDv2hmsZmokGiV {
  background: var(--secondary-button-background);
  border: 0.125rem solid var(--secondary-button-border-color);
  box-sizing: border-box;
  border-radius: 2.5rem;
  color: var(--secondary-button-text-color)
}

.pJ5lpFCDv2hmsZmokGiV:hover:not([disabled]) {
    border: 0.125rem solid var(--secondary-button-hover-color);
    transition: 0.3s;
    color: var(--secondary-button-hover-color);
  }

.gqv3r2WFNnJtstbCMzuI {
  background: var(--secondary-button-background);
  border-color: var(--secondary-button-border-color-alt);
  color: var(--secondary-button-text-color-alt)
}

.gqv3r2WFNnJtstbCMzuI:hover:not([disabled]) {
    border-color: var(--secondary-button-hover-color-alt);
    color: var(--secondary-button-hover-color-alt);
  }

.reVv2m92MRG7aEyDbwyW {
  background: var(--white);
  border: 0.125rem solid var(--secondaryWarning-button-color);
  box-sizing: border-box;
  border-radius: 2.5rem;
  color: var(--secondaryWarning-button-color)
}

.reVv2m92MRG7aEyDbwyW:hover:not([disabled]) {
    border: 0.125rem solid var(--action-CTA-secondaryWarning-tap);
    transition: 0.3s;
    color: var(--action-CTA-secondaryWarning-tap);
  }

.odtOENRM8nO67fi6A2f8 {
  background: var(--white);
  box-sizing: border-box;
  padding: 0 1.5rem;
  color: var(--midnight-purple);
  border: 0.0625rem solid var(--grey-200);
  box-shadow: 0 0.25rem 0.75rem var(--black-012);
  border-radius: var(--panel-narrow-border-radius)
}

.odtOENRM8nO67fi6A2f8:hover:not([disabled]) {
    transition: 0.3s;
    border: 0.0625rem solid var(--purple);
    box-shadow: 0 0.25rem 0.75rem var(--black-012);
  }

.yJmXDmy7f2C2dFexmqOR {
  background: var(--white);
  border-radius: 2.5rem;
  color: var(--quaternary-button-background);
  border: 0.0625rem solid var(--quaternary-button-background)
}

.yJmXDmy7f2C2dFexmqOR:hover:not([disabled]) {
    color: var(--quaternary-button-hover-background);
    border-color: var(--quaternary-button-hover-background);
    transition: 0.3s;
  }

.yJmXDmy7f2C2dFexmqOR.v8v841M4DCcuCAwgrgy4 {
    color: var(--quaternary-button-inactive-background);
    border-color: var(--quaternary-button-inactive-background);
    opacity: 1;
  }

.KOUNNw4nl9mRKbFyp02e {
  background: var(--quaternary-button-reversed-background);
  border-radius: 2.5rem;
  color: var(--white)
}

.KOUNNw4nl9mRKbFyp02e:hover:not([disabled]) {
    background: var(--quaternary-button-reversed-hover-background);
    transition: 0.3s;
  }

.KOUNNw4nl9mRKbFyp02e.v8v841M4DCcuCAwgrgy4 {
    background: var(--quaternary-button-reversed-inactive-background);
    opacity: 1;
  }

.fiaIW8EzjGBgQZzGxp9a {
  background: var(--quinary-button-background);
  border: 0.125rem solid var(--quinary-button-border-color);
  box-sizing: border-box;
  border-radius: 2.5rem;
  color: var(--quinary-button-text-color)
}

.fiaIW8EzjGBgQZzGxp9a:hover:not([disabled]) {
    border: 0.125rem solid var(--quinary-button-hover-border-color);
    background: var(--quinary-button-hover-background);
    color: var(--quinary-button-hover-text-color);
    transition: 0.3s;
  }

.XG5Nmyxkf9PzCb5x6Qsz {
  background: var(--primary-button-background-alt);
  border-radius: 2.5rem;
  color: var(--white)
}

.XG5Nmyxkf9PzCb5x6Qsz:hover:not([disabled]) {
    background: var(--primary-button-hover-background-alt);
    transition: 0.3s;
  }

.XG5Nmyxkf9PzCb5x6Qsz.v8v841M4DCcuCAwgrgy4 {
    background: var(--primary-button-inactive-background-alt);
  }

.S291L7eeNyZg_jBGNTzr {
  height: auto;
  background: transparent;
  font-weight: var(--button-linkish-font-weight);
  color: var(--primary-link-color);
  padding: 0
}

.S291L7eeNyZg_jBGNTzr:hover:not([disabled]) {
    transition: 0.3s;
    -webkit-text-decoration-line: underline;
            text-decoration-line: underline
  }

.S291L7eeNyZg_jBGNTzr:hover:not([disabled]) p {
      -webkit-text-decoration-line: underline;
              text-decoration-line: underline;
    }

.HOoKzxvWVV2alYTXi0Sq {
  color: var(--primary-link-color);
}

.p6xMhVElfjR3tDrJ5Lcy:hover:not([disabled]) {
    -webkit-text-decoration-line: none;
            text-decoration-line: none
  }

.p6xMhVElfjR3tDrJ5Lcy:hover:not([disabled]) p {
      -webkit-text-decoration-line: none;
              text-decoration-line: none;
    }

.Zsuj4SmMCq7c3Px6xUw6 {
  width: unset;
}

.GqZkmJl4Bmn1mC0gfr65 {
  width: 100%;
}

.v8v841M4DCcuCAwgrgy4 {
  opacity: 0.4;
}
`, "",{"version":3,"sources":["webpack://./src/components/Button/Button.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,mBAAe;EACf,qBAAiB;;EAEjB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,iBAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB;AAOF;;AALE;IACE,aAAa;IACb,gBAAgB;IAChB,eAAe;EACjB;;AAGF;EACE,mBAAmB;AACrB;;AAEA;;IAEI;MACE,iBAAc;IAChB;AAEJ;;AAEA;EACE,mBAAmB;EACnB;AAUF;;AARE;IACE,mBAAmB;IACnB,kBAAe;EACjB;;AAEA;IACE,kBAAkB;EACpB;;AAGF;EACE,kBAAkB;EAClB,qBAAa;UAAb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,4CAA4C;AAC9C;;AAEA;EACE,4CAA4C;EAC5C,qBAAmB;EACnB;AAWF;;AATE;IACE,kDAAkD;IAClD,gBAAgB;EAClB;;AAEA;IACE,qDAAqD;IACrD,UAAU;EACZ;;AAGF;EACE;AASF;;AAPE;IACE,sDAAsD;EACxD;;AAEA;IACE,yDAAyD;EAC3D;;AAGF;EACE,8CAA8C;EAC9C,2DAAsD;EACtD,sBAAsB;EACtB,qBAAmB;EACnB;AAOF;;AALE;IACE,0DAAqD;IACrD,gBAAgB;IAChB,0CAA0C;EAC5C;;AAGF;EACE,8CAA8C;EAC9C,sDAAsD;EACtD;AAMF;;AAJE;IACE,qDAAqD;IACrD,8CAA8C;EAChD;;AAGF;EACE,wBAAwB;EACxB,2DAAsD;EACtD,sBAAsB;EACtB,qBAAmB;EACnB;AAOF;;AALE;IACE,6DAAwD;IACxD,gBAAgB;IAChB,6CAA6C;EAC/C;;AAGF;EACE,wBAAwB;EACxB,sBAAsB;EACtB,iBAAe;EACf,6BAA6B;EAC7B,uCAAiC;EACjC,8CAAuC;EACvC;AAOF;;AALE;IACE,gBAAgB;IAChB,qCAA+B;IAC/B,8CAAuC;EACzC;;AAGF;EACE,wBAAwB;EACxB,qBAAmB;EACnB,0CAA0C;EAC1C;AAaF;;AAXE;IACE,gDAAgD;IAChD,uDAAuD;IACvD,gBAAgB;EAClB;;AAEA;IACE,mDAAmD;IACnD,0DAA0D;IAC1D,UAAU;EACZ;;AAGF;EACE,wDAAwD;EACxD,qBAAmB;EACnB;AAWF;;AATE;IACE,8DAA8D;IAC9D,gBAAgB;EAClB;;AAEA;IACE,iEAAiE;IACjE,UAAU;EACZ;;AAGF;EACE,4CAA4C;EAC5C,yDAAoD;EACpD,sBAAsB;EACtB,qBAAmB;EACnB;AAQF;;AANE;IACE,+DAA0D;IAC1D,kDAAkD;IAClD,6CAA6C;IAC7C,gBAAgB;EAClB;;AAGF;EACE,gDAAgD;EAChD,qBAAmB;EACnB;AAUF;;AARE;IACE,sDAAsD;IACtD,gBAAgB;EAClB;;AAEA;IACE,yDAAyD;EAC3D;;AAGF;EACE,YAAY;EACZ,uBAAuB;EACvB,8CAA8C;EAC9C,gCAAgC;EAChC;AAUF;;AARE;IACE,gBAAgB;IAChB,uCAA+B;YAA/B;EAKF;;AAHE;MACE,uCAA+B;cAA/B,+BAA+B;IACjC;;AAIJ;EACE,gCAAgC;AAClC;;AAGE;IACE,kCAA0B;YAA1B;EAKF;;AAHE;MACE,kCAA0B;cAA1B,0BAA0B;IAC5B;;AAIJ;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd","sourcesContent":[".button {\n  height: 64px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: 0.3s;\n  font-weight: var(--button-font-weight);\n  font-size: 18px;\n  line-height: 22px;\n\n  /* reset */\n  border: none;\n  outline: none;\n  overflow: visible;\n  padding: 0 40px;\n  user-select: none;\n  position: relative;\n\n  &.contentLineBreak {\n    height: unset;\n    min-height: 64px;\n    padding: 0 16px;\n  }\n}\n\n.withNormalWhiteSpace {\n  white-space: normal;\n}\n\n@media (--mobile) {\n  .button {\n    &.contentLineBreak {\n      padding: 0 8px;\n    }\n  }\n}\n\n.content {\n  white-space: nowrap;\n  width: 100%;\n\n  &.contentLineBreakInner {\n    white-space: normal;\n    padding: 12px 0;\n  }\n\n  &.hidden {\n    visibility: hidden;\n  }\n}\n\n.noWrap {\n  white-space: unset;\n  hyphens: auto;\n  word-break: break-word;\n}\n\n.loaderContainer {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) scale(0.35);\n}\n\n.primary {\n  background: var(--primary-button-background);\n  border-radius: 40px;\n  color: var(--white);\n\n  &:hover:not([disabled]) {\n    background: var(--primary-button-hover-background);\n    transition: 0.3s;\n  }\n\n  &.disabled {\n    background: var(--primary-button-inactive-background);\n    opacity: 1;\n  }\n}\n\n.primaryAlt {\n  background: var(--primary-button-background-alt);\n\n  &:hover:not([disabled]) {\n    background: var(--primary-button-hover-background-alt);\n  }\n\n  &.disabled {\n    background: var(--primary-button-inactive-background-alt);\n  }\n}\n\n.secondary {\n  background: var(--secondary-button-background);\n  border: 2px solid var(--secondary-button-border-color);\n  box-sizing: border-box;\n  border-radius: 40px;\n  color: var(--secondary-button-text-color);\n\n  &:hover:not([disabled]) {\n    border: 2px solid var(--secondary-button-hover-color);\n    transition: 0.3s;\n    color: var(--secondary-button-hover-color);\n  }\n}\n\n.secondaryAlt {\n  background: var(--secondary-button-background);\n  border-color: var(--secondary-button-border-color-alt);\n  color: var(--secondary-button-text-color-alt);\n\n  &:hover:not([disabled]) {\n    border-color: var(--secondary-button-hover-color-alt);\n    color: var(--secondary-button-hover-color-alt);\n  }\n}\n\n.secondaryWarning {\n  background: var(--white);\n  border: 2px solid var(--secondaryWarning-button-color);\n  box-sizing: border-box;\n  border-radius: 40px;\n  color: var(--secondaryWarning-button-color);\n\n  &:hover:not([disabled]) {\n    border: 2px solid var(--action-CTA-secondaryWarning-tap);\n    transition: 0.3s;\n    color: var(--action-CTA-secondaryWarning-tap);\n  }\n}\n\n.tertiary {\n  background: var(--white);\n  box-sizing: border-box;\n  padding: 0 24px;\n  color: var(--midnight-purple);\n  border: 1px solid var(--grey-200);\n  box-shadow: 0 4px 12px var(--black-012);\n  border-radius: var(--panel-narrow-border-radius);\n\n  &:hover:not([disabled]) {\n    transition: 0.3s;\n    border: 1px solid var(--purple);\n    box-shadow: 0 4px 12px var(--black-012);\n  }\n}\n\n.quaternary {\n  background: var(--white);\n  border-radius: 40px;\n  color: var(--quaternary-button-background);\n  border: 1px solid var(--quaternary-button-background);\n\n  &:hover:not([disabled]) {\n    color: var(--quaternary-button-hover-background);\n    border-color: var(--quaternary-button-hover-background);\n    transition: 0.3s;\n  }\n\n  &.disabled {\n    color: var(--quaternary-button-inactive-background);\n    border-color: var(--quaternary-button-inactive-background);\n    opacity: 1;\n  }\n}\n\n.quaternaryReversed {\n  background: var(--quaternary-button-reversed-background);\n  border-radius: 40px;\n  color: var(--white);\n\n  &:hover:not([disabled]) {\n    background: var(--quaternary-button-reversed-hover-background);\n    transition: 0.3s;\n  }\n\n  &.disabled {\n    background: var(--quaternary-button-reversed-inactive-background);\n    opacity: 1;\n  }\n}\n\n.quinary {\n  background: var(--quinary-button-background);\n  border: 2px solid var(--quinary-button-border-color);\n  box-sizing: border-box;\n  border-radius: 40px;\n  color: var(--quinary-button-text-color);\n\n  &:hover:not([disabled]) {\n    border: 2px solid var(--quinary-button-hover-border-color);\n    background: var(--quinary-button-hover-background);\n    color: var(--quinary-button-hover-text-color);\n    transition: 0.3s;\n  }\n}\n\n.primaryCheckOutV2 {\n  background: var(--primary-button-background-alt);\n  border-radius: 40px;\n  color: var(--white);\n\n  &:hover:not([disabled]) {\n    background: var(--primary-button-hover-background-alt);\n    transition: 0.3s;\n  }\n\n  &.disabled {\n    background: var(--primary-button-inactive-background-alt);\n  }\n}\n\n.linkish {\n  height: auto;\n  background: transparent;\n  font-weight: var(--button-linkish-font-weight);\n  color: var(--primary-link-color);\n  padding: 0;\n\n  &:hover:not([disabled]) {\n    transition: 0.3s;\n    text-decoration-line: underline;\n\n    & p {\n      text-decoration-line: underline;\n    }\n  }\n}\n\n.linkishAlt {\n  color: var(--primary-link-color);\n}\n\n.withoutHoverStyles {\n  &:hover:not([disabled]) {\n    text-decoration-line: none;\n\n    & p {\n      text-decoration-line: none;\n    }\n  }\n}\n\n.inline {\n  width: unset;\n}\n\n.fill {\n  width: 100%;\n}\n\n.disabled {\n  opacity: 0.4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `AisLsJaE_AWnIhDlnTUV`,
	"contentLineBreak": `DHBUqUbAMMfB0v3PgvXr`,
	"withNormalWhiteSpace": `ZsVSWr4yl0WLP8wkMn40`,
	"content": `pYLUj9noAqT8WytjDOOb`,
	"contentLineBreakInner": `_jQ18NByxdvafkEjPWkf`,
	"hidden": `acaZyRNE4xfXFf2H3_Pj`,
	"noWrap": `ntiSVvdX4_Z4uEfI2VNc`,
	"loaderContainer": `FINn846WpvpReeRlLCKs`,
	"primary": `cdc4_xoyu5lt350lFjqA`,
	"disabled": `v8v841M4DCcuCAwgrgy4`,
	"primaryAlt": `O3f7ruZEAN4tCb1_HN2w`,
	"secondary": `pJ5lpFCDv2hmsZmokGiV`,
	"secondaryAlt": `gqv3r2WFNnJtstbCMzuI`,
	"secondaryWarning": `reVv2m92MRG7aEyDbwyW`,
	"tertiary": `odtOENRM8nO67fi6A2f8`,
	"quaternary": `yJmXDmy7f2C2dFexmqOR`,
	"quaternaryReversed": `KOUNNw4nl9mRKbFyp02e`,
	"quinary": `fiaIW8EzjGBgQZzGxp9a`,
	"primaryCheckOutV2": `XG5Nmyxkf9PzCb5x6Qsz`,
	"linkish": `S291L7eeNyZg_jBGNTzr`,
	"linkishAlt": `HOoKzxvWVV2alYTXi0Sq`,
	"withoutHoverStyles": `p6xMhVElfjR3tDrJ5Lcy`,
	"inline": `Zsuj4SmMCq7c3Px6xUw6`,
	"fill": `GqZkmJl4Bmn1mC0gfr65`
};
export default ___CSS_LOADER_EXPORT___;
